module.exports = __webpack_public_path__ + "img/home2.0d759597.png";